import { AxiosResponse } from "axios";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../../axios/axios.config";
import {
  ConfiguracaoCaixaCheckDTO,
  ConfiguracaoCaixaDTO,
} from "./configuracao-caixa.model";

const ConfiguracaoCaixaService = () => {
  const path = "/configuracoes/caixa";
  const loginService = LoginService();

  return {
    getConfiguracao(): Promise<AxiosResponse<ConfiguracaoCaixaDTO>> {
      return axiosRequest.get(path, {
        headers: loginService.getHeaders(),
      });
    },

    update(
      payload: ConfiguracaoCaixaDTO
    ): Promise<AxiosResponse<ConfiguracaoCaixaDTO>> {
      return axiosRequest.put(path, payload, {
        headers: loginService.getHeaders(),
      });
    },

    check(): Promise<AxiosResponse<ConfiguracaoCaixaCheckDTO>> {
      return axiosRequest.get(`${path}/check`, {
        headers: loginService.getHeaders(),
      });
    },
  };
};

export default ConfiguracaoCaixaService;
